







































import Vue from 'vue';

export default Vue.extend({
  name: 'UploadSite',
  props: {
    busy: Boolean,
    error: Boolean
  },
  data: function () {
    return {
      file: '',
      onHover: false
    };
  },
  methods: {
    onChange() {
      this.file = this.$refs.file.files[0];
      // Maximum allowed size in bytes
      const maxAllowedSize = 10 * 1024 * 1024;
      if (this.file.size > maxAllowedSize) {
        this.file = '';
        window.alert("Maximum file size exceeded!");
        return;
      }
      this.$emit('file', this.file);
    },
    remove() {
      this.file = '';
      this.$emit('file', null);
    },
    process() {
      this.$emit('process', true);
    },
    dragover(event) {
      event.preventDefault();
      this.onHover = true;
    },
    dragleave() {
      this.onHover = false;
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange();
      this.onHover = false;
    }
  }
});
